import React from "react";
import { useState, useEffect, useRef } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";
import { main_link } from "../Connection/Connection";

import axios from "axios";

import { Toast } from "primereact/toast";

//
function EditCuts(props) {
  // console.log(props);

  const toast = useRef(null);

  const show = props.showEdit;
  const setShow = props.setShowEdit;
  const cut = props.cutDetails;
  const counter = props.counter;
  const setCounter = props.setCounter;

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [name, setName] = useState();
  const [price, setPrice] = useState();
  const [id, setId] = useState();

  useEffect(() => {
    if (cut) {
      setName(cut.name || "");
      setPrice(cut.price || "");
      setId(cut.cut_id || "");
    }
  }, [props]);

  const [loading, setLoading] = useState(false);

  const update = async (e) => {
    e.preventDefault();
    setLoading(true);

    const user = JSON.parse(sessionStorage.getItem("user-data"));
    const user_id = user?.encrypted_id;
    // console.log(name + " " + price);
    if (name && price) {
      try {
        const response = await axios.post(main_link + "editCut", {
          user_id,
          id,
          name,
          price,
        });

        if (response.data.message === "Saved Successfully.") {
          toast.current.show({
            severity: "success",
            summary: "success",
            detail: "Saved Successfully.",
          });
          setShow(false);
          setCounter(counter + 1);
        }

        setLoading(false);
      } catch (e) {
        toast.current.show({
          severity: "error",
          summary: "error",
          detail: "All Fields Are Required",
        });
      }
    }

    setLoading(false);
  };

  const showHideCut = async (e) => {
    e.preventDefault();
    setLoading(true);

    const user = JSON.parse(sessionStorage.getItem("user-data"));
    const user_id = user?.encrypted_id;
    if (name && price) {
      try {
        const response = await axios.post(main_link + "showHideCut", {
          user_id,
          id,
        });

        if (response.data.message === "Saved Successfully.") {
          toast.current.show({
            severity: "success",
            summary: "success",
            detail: "Saved Successfully.",
          });
          setShow(false);
          setCounter(counter + 1);
        }
        // console.log(response.data);
        setLoading(false);
      } catch (e) {
        console.log(e);
        toast.current.show({
          severity: "error",
          summary: "error",
          detail: "All Fields Are Required",
        });
      }
    }

    setLoading(false);
  };
  return (
    <>
      <Toast ref={toast} />

      <Modal show={show} onHide={handleClose} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            Update {cut.type} ~<i>{cut.name}</i>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {" "}
          <Form id="addBeardCut">
            <Container>
              <Row>
                <Col lg={4} md={6} sm={4}>
                  <Form.Group className="mb-3" controlId="Name.ControlInput1">
                    <Form.Label>Name</Form.Label>
                    <Form.Control
                      type="name"
                      placeholder="Cut Name"
                      onChange={(e) => setName(e.target.value)}
                      defaultValue={cut.name}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4} md={6} sm={4}>
                  <Form.Group className="mb-3" controlId="Price.ControlInput1">
                    <Form.Label>Price in $</Form.Label>
                    <Form.Control
                      type="name"
                      placeholder="Price"
                      onChange={(e) => setPrice(e.target.value)}
                      defaultValue={cut.price}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4} md={6} sm={4}>
                  <Form.Group className="mb-3" controlId="Price.ControlInput1">
                    <Form.Label>
                      {cut.isRemoved === "1" ? "Status Hidden" : "Status Shown"}
                    </Form.Label>
                    <Button
                      variant={cut.isRemoved === "1" ? "danger" : "primary"}
                      style={{ width: "100%" }}
                      onClick={(e) => showHideCut(e)}
                    >
                      {cut.isRemoved === "1" ? "Show Cut" : "Hide Cut"}
                    </Button>
                  </Form.Group>
                </Col>
              </Row>
            </Container>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          {!loading && (
            <Button variant="success" onClick={update}>
              Save Update{" "}
            </Button>
          )}
          {loading && (
            <Button variant="success" disabled="disabled">
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />{" "}
              Updating...
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default EditCuts;
